import ApiPermisos from "../../services/apiPermisos";

export default {
  namespaced: true,
  state: {
    errorMsj: "",
    categories: [],
    pointSales: { data: null, meta: null, links: null },
    pointsale: { id: null },
    loading: false,
    loadingSave: false,
    loadingIndex: false,
    pointSaleIndex: [],
    historial: { data: null, meta: null, links: null },
    loadingHistorial: false,
    pdvs: [],
    loadingPdvs: false,
    error: "",
    message: "",
  },
  getters: {
    getAllTurnos: (state) => {
      return state.turnos;
    },
  },
  mutations: {
    setpointSales: (state, pointSales) => {
      state.pointSales = pointSales;
    },

    setPointSale: (state, pointsale) => {
      console.log("state ",state);
      console.log("pointsale ",pointsale);
      state.pointsale = [];
      state.pointsale = pointsale;
    },
    setLoading: (state, loading) => {
      state.loading = loading;
    },

    setLoadingHistorial: (state, loadingHistorial) => {
      state.loadingHistorial = loadingHistorial;
    },

    setLoadingIndex: (state, loadingIndex) => {
      state.loadingIndex = loadingIndex;
    },

    setLoadingSave: (state, loadingSave) => {
      state.loadingSave = loadingSave;
    },

    setPointSaleIndex: (state, pointSaleIndex) => {
      state.pointSaleIndex = [];
      state.pointSaleIndex = pointSaleIndex;
    },

    setHistorial: (state, historial) => {
      state.historial = historial;
    },

    setPdvs: (state, pdvs) => {
      state.pdvs = pdvs;
      console.log("pdvs", pdvs);
    },

    setLoadingPdvs: (state, loadingPdvs) => {

      console.log("load_pdvs",state.loadingPdvs);
      state.loadingPdvs = loadingPdvs;
      console.log("pdvs", loadingPdvs);
    },

    setMessage: (state, message) => {
      state.error = null;
      state.message = message;
    },

    setError: (state, error) => {
      state.message = null;
      state.error = error;
    },
  },
  actions: {
    //Trae listado de las personas
    actGetDatatable: async ({ commit }, data) => {
      commit("setLoading", true);
      await ApiPermisos.getReportPdvEscenarios(data)
        .then((response) => {
          commit("setLoading", false);
          commit("setpointSales", response);
          return response;
        })
        .catch((response) => {
          commit("setLoading", false);
          commit("setMessage", "Ocurrió un error eliminado el scenario");
          return response;
        });
    },

    // Obtener carga de la página
    actGetIndex: async ({ commit }) => {
      commit("setLoadingIndex", true);
      let response = await ApiPermisos.actGetIndex();
      if (response.error) {
        return response.error;
      } else {
        commit("setLoadingIndex", false);
        commit("setPointSaleIndex", response);
      }
      return response;
    },

    //Guardar escenarios con los PDV
    actSavePdvEscenarios: async ({ commit }, data) => {
      try {
        commit("setLoadingSave", true);
        await ApiPermisos.saveReportPdvEscenarios(data)
          .then((response) => {
            response.error
              ? commit("setError", response.error)
              : commit("setMessage", response.message);
            commit("setLoadingSave", false);
            return response;
          })
          .catch((response) => {
            commit("setLoadingSave", false);
            commit("setMessage", "Ocurrió un error actualizando el escenario");
            return response;
          });
      } catch (error) {
        commit("setLoadingSave", false);
        commit(
          "setError",
          "Ocurrió un error actualizando el escenario. 'store'"
        );
        return error;
      }
    },

    actGetHistorialTables: async ({ commit }, data) => {
      commit("setLoadingHistorial", true);
      let response = await ApiPermisos.getReportHistoryTables(data);
      if (response.error) {
        commit("setLoadingHistorial", false);
        return response.error;
      } else {
        commit("setLoadingHistorial", false);
        commit("setHistorial", response);
      }
      return response;
    },

    actGetPdvs: async ({ commit }) => {
      commit("setLoadingPdvs", true);
      let response = await ApiPermisos.getAutocompletePdvs();
     // let response = await ApiPermisos.getPointsSales(data);
      if (response.error) {
        console.log("auto-com",response.error);
        commit("setLoadingPdvs", false);
        return response.error;
      } else {
        commit("setLoadingPdvs", false);
        console.log("rersponde",response.data);
        commit("setPdvs", response.data);
      }

      console.log("pdv", response.data);
      return response;
    },

    actSetPointSale: async ({ commit }, data) => {
      console.log("data_editar",data);
      commit("setPointSale", data);
    },

    actSetError({ commit }, error) {
      commit("setError", error);
    },

    // Guarda mensaje de exito

    actSetMessage({ commit }, message) {
      commit("setMessage", message);
    },
  },
};
